module.exports = __webpack_public_path__ + "static/media/quotemark-icon.1d3b6c2a.svg";